// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"ImportEntireRuleset_submitButton__3xslo","loader":"ImportEntireRuleset_loader__30zYf"};